<template>
  <b-row>
    <b-col cols="12" xl="6">
      <b-form-group>
        <label>{{ 'user' | translate('global') }}</label>
        <treeselect :class="{ 'treeselect-error' : errorMsg.user_id }"
                    :default-expand-level="1" :placeholder="'user_name_select' | translate('global')"
                    instanceId="loadUsers"
                    :load-options="loadOptions" :async="true" :cacheOptions="false"
                    :searchPromptText="'user_name_autocomplete' | translate('global')"
                    :noResultsText="'no_results_found' | translate('global')"
                    v-model="user"/>
        <span class="error-text" v-if="errorMsg.user_id">{{ errorMsg.user_id[0] }}</span>
      </b-form-group>
    </b-col>
    <b-col cols="12" xl="6">
      <b-form-group>
        <label>{{ 'role' | translate('global') }}</label>
        <treeselect :class="{ 'treeselect-error' : errorMsg.role_id }"
                    :placeholder=" 'role_select' | translate('global') "
                    :options="roleOptions" v-model="role"/>
        <span class="error-text" v-if="errorMsg.role_id">{{ errorMsg.role_id[0] }}</span>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-button block type="submit" variant="primary" class="pull-right" :disabled="spinners.isSaving"
                @click="onSave()">
        <b-spinner v-if="spinners.isSaving" type="grow" small/>
        {{ 'add' | translate('global') }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import forEach from 'lodash.foreach';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TreeselectMixin from '@/mixins/TreeselectMixin';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const UsersService = Services.users;
const StructureTypes = VuexTypes.structures;
export default {
  props: {
    roleOptions: {
      type: Array,
    },
  },
  mixins: [TreeselectMixin],
  data() {
    return {
      spinners: {
        isSaving: false,
      },
      user: null,
      role: null,
      errorMsg: {}
    };
  },
  components: {
    Treeselect
  },
  computed: {
    ...mapGetters('Structures', [
      'addUser',
    ]),
  },
  watch: {
    addUser: {
      handler: function () {
        this.errorMsg = {};
        this.spinners.isSaving = false;
        if (this.addUser.status === statuses.LOADED) {
          this.alertSuccess();
          this.user = null;
          this.role = null;
        } else if (this.addUser.status === statuses.ERROR) {
          this.errorMsg = this.addUser.data.data.errors;
          if (this.errorMsg['structure_id']) {
            this.alertError({ text: this.$t('error_structure_user_with_role_exist', 'global') });
          } else {
            this.alertError();
          }
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Structures', [
      StructureTypes.ADD_USER
    ]),
    async loadOptions({ action, searchQuery, callback, instanceId }) {
      let options = [];
      const query = searchQuery.trim();
      if (action === 'ASYNC_SEARCH') {
        const valid = this.checkSearchQuery(query);
        if (valid) {
          options = await this[instanceId](query);
        }
      }
      callback(null, options);
    },
    async loadUsers(name) {
      const param = name || '';
      const data = await UsersService.search(param);
      const options = [];
      forEach(data.data.data, (item) => {
        options.push({
          id: item['id'],
          label: item['full_name']
        });
      });
      return options;
    },
    onSave() {
      this.spinners.isSaving = true;
      const saveData = {
        structure_id: this.$route.params.id,
        user_id: this.user,
        role_id: this.role,
      };
      this.ADD_USER(saveData);
    },
  }
};
</script>

<style scoped>
</style>
